import {BaseEvent} from "../BaseEvent";

export class NotificationTokenExpiredNtf extends BaseEvent {
  public static NAME = 'notificationTokenExpired';

  constructor() {
    super(NotificationTokenExpiredNtf.NAME);
  }
}
